import React ,{useRef ,useEffect}from 'react';
import './chart-of-account.scss'
import DynamicInputList from '../software-dynamic-version-3/list-input-v-3';
import moment from 'moment'
import SecurityService from '../security/security.service';
import chartOfAccountService from '../../services/chart-of-account.service';
import ChartOfAccount from './chart-of-account';
import DialogInput from '../software-dynamic-version-3/popup-dialog-input-v-3';
import AuditTable from '../audit-table/audit-table'
import securityService from '../security/security.service';



const ChartOfAccountInput = (props) => {
  // ACode	ChartOfAccountLevel	AName	ShortName	Transactional	Inactive	BalType	OpBal	ShowOpeningBalance	Folio	CashCredit	CompanyID
  
  let columns =
  [

    {  field: "AccountID",headerText:'ID',width:'90px',textAlign:'right' ,headerTextAlign:'center',other:[]},
    {  field: "AccountCode",headerText:'Account Code',width:'130px',textAlign:'left' ,headerTextAlign:'center',other:[]},
    {  field: "AccountTitle",headerText:'Account Title',width:'200px',textAlign:'left' ,headerTextAlign:'center',other:[]},
    {  field: "Transactional",headerText:'Trans',width:'110px',textAlign:'right' ,headerTextAlign:'center',other:[]},
    {  field: "Inactive",headerText:'In active',width:'110px',textAlign:'right' ,headerTextAlign:'center',other:[]},
    {  field: "AccountType",headerText:'Acc. Type',width:'130px',textAlign:'right' ,headerTextAlign:'center',other:[]},
    {  field: "OpeningBalance",headerText:'Opening Balance',width:'140px',textAlign:'right' ,headerTextAlign:'center',other:[{'format':'n0'}]},
    {  field: "CreditDays",headerText:'Credit Days',width:'140px',textAlign:'right' ,headerTextAlign:'center',other:[{'format':'n0',visible:false}]},
    {  field: "CreditAmountLimit",headerText:'Credit Amount Limit',width:'140px',textAlign:'right' ,headerTextAlign:'center',other:[{'format':'n0',visible:false}]},
    {  field: "ContactPerson",headerText:'Contact Person',width:'140px',textAlign:'right' ,headerTextAlign:'center',other:[{visible:false}]},
    {  field: "OfficeAddress",headerText:'Office Address',width:'140px',textAlign:'right' ,headerTextAlign:'center',other:[{visible:false}]},
    {  field: "LandlineNumber",headerText:'Landline Number',width:'140px',textAlign:'right' ,headerTextAlign:'center',other:[{visible:false}]},
    {  field: "CellNumber",headerText:'Cell Number',width:'140px',textAlign:'right' ,headerTextAlign:'center',other:[{visible:false}]},
    {  field: "AccountCategory",headerText:'Account Category',width:'140px',textAlign:'right' ,headerTextAlign:'center',other:[{visible:false}]},
    {  field: "NTN",headerText:'NTN',width:'140px',textAlign:'right' ,headerTextAlign:'center',other:[{'format':'n0',visible:false}]},
    {  field: "STRN",headerText:'STRN',width:'140px',textAlign:'right' ,headerTextAlign:'center',other:[{'format':'n0',visible:false}]},
    {  field: "EmailAddress",headerText:'Email Address',width:'140px',textAlign:'right' ,headerTextAlign:'center',other:[{visible:false}]},
    {  field: "Aging",headerText:'Aging',width:'140px',textAlign:'right' ,headerTextAlign:'center',other:[{visible:false}]},
  ]

            const userId = SecurityService.getLoggedInUserId();
        
        const listActionComplete = async (grid , args ,getListService ,selectedRow  ,setDataSourceState ,addUserLog,editUserLog)=>{
          console.log(args )
        console.log(getListService )
        console.log(selectedRow )
        if (args.requestType === 'beginEdit' || args.requestType === 'add') {
          }
        if (args.requestType === 'save' || args.requestType ==  'cancel') {
                      
                      getListService()
                      // chartOfAccountGrid.refresh();
        
                    }
                    if (args.requestType === 'save' && args.data.ActionType ==  'Add') {
                      console.log(args.data)
                      function convertToMozambiqueTime(dateString) {
                        // Parse the date string with the GMT offset
                        const gmtDate = moment(dateString, "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
                        
                        // Convert the parsed date to Mozambique time zone (Africa/Maputo)
                        const dateInMozambique = gmtDate.tz("Africa/Maputo").format('DD-MMM-YY');
                        
                        return dateInMozambique;
                    }
                        const data = {
                           AccountCode:args.data.AccountCode
                          ,AccountTitle:args.data.AccountTitle
                          ,AccountTitleShort:args.data.AccountTitle
                          ,Transactional:args.data.Transactional == false ? '0':'1'
                          ,Inactive:args.data.Inactive == false ? '0':'1'
                          ,AccountTypeID:args.data.AccountTypeID
                          ,OpeningBalance:args.data.OpeningBalance
                          ,CreditDays:args.data.CreditDays
                          ,CreditAmountLimit:args.data.CreditAmountLimit
                          ,ContactPerson:args.data.ContactPerson == undefined ? '-' : args.data.ContactPerson
                          ,OfficeAddress:args.data.OfficeAddress == undefined ? '-' : args.data.OfficeAddress
                          ,LandlineNumber:args.data.LandlineNumber == undefined ? '-' : args.data.LandlineNumber
                          ,CellNumber:args.data.CellNumber == undefined ? '-' : args.data.CellNumber
                          ,NTN:args.data.NTN == undefined ? '-' : args.data.NTN
                          ,STRN:args.data.STRN == undefined ? '-' :args.data.STRN
                          ,EmailAddress:args.data.EmailAddress == undefined ? '-' : args.data.EmailAddress
                          ,AccountCategoryID:args.data.AccountCategoryID
                          ,Aging:args.data.Aging == false ? '0':'1'
                          ,TRNNo:args.data.TRNNo || '-'
                          ,AdditionalPaymentID:args.data.AdditionalPaymentID
                         ,   ApprovedByDate: moment().format('YYYY-MM-DD'),
                            CreatedByUserID: userId,
                            CompanyID:securityService.getCompanyIDLoggedInUserId(),
                            TransactionDate: convertToMozambiqueTime(args.data.TransactionDate)
                        }
                        console.log('args: ', data)
                        chartOfAccountService.create(data)
                            .then((response) => {
                               
                              getListService()
                                
                            });
        
                    }
                    if (args.requestType === 'save' && args.data.ActionType ==  'Edit') {
                      console.log(args.data)
                        const data = {
                           AccountCode:args.data.AccountCode
                          ,AccountTitle:args.data.AccountTitle
                          ,AccountTitleShort:args.data.AccountTitle
                          ,Transactional:args.data.Transactional == false ? '0':'1'
                          ,Inactive:args.data.Inactive == false ? '0':'1'
                          ,AccountTypeID:args.data.AccountTypeID
                          ,OpeningBalance:args.data.OpeningBalance
                          ,CreditDays:args.data.CreditDays
                          ,CreditAmountLimit:args.data.CreditAmountLimit
                          ,ContactPerson:args.data.ContactPerson == undefined ? '-' : args.data.ContactPerson
                          ,OfficeAddress:args.data.OfficeAddress == undefined ? '-' : args.data.OfficeAddress
                          ,LandlineNumber:args.data.LandlineNumber == undefined ? '-' : args.data.LandlineNumber
                          ,CellNumber:args.data.CellNumber == undefined ? '-' : args.data.CellNumber
                          ,NTN:args.data.NTN == undefined ? '-' : args.data.NTN
                          ,STRN:args.data.STRN == undefined ? '-' :args.data.STRN
                          ,EmailAddress:args.data.EmailAddress == undefined ? '-' : args.data.EmailAddress
                          ,AccountCategoryID:args.data.AccountCategoryID
                          ,Aging:args.data.Aging == false ? '0':'1'
                         ,   ApprovedByDate: moment().format('YYYY-MM-DD'),
                            CreatedByUserID: userId,
                            CompanyID:securityService.getCompanyIDLoggedInUserId(),
                            TRNNo:args.data.TRNNo || '-'
                          ,AdditionalPaymentID:args.data.AdditionalPaymentID,
                            TransactionDate: moment(args.data.TransactionDate).format('YYYY-MM-DD')
                        }
                        console.log('args: ', data)
                        chartOfAccountService.update(data)
                            .then((response) => {
                               
                              getListService()
                                
                            });
        
                    }
        
              
        
             
            
            
              }
        
      
       //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************

        // Defines the  boolean
        // @default true
    let  allowTemplate = false
    let  allowGrouping = true
    let  allowExcelExport =true
    let  allowPdfExport = true
    let  showColumnChooser = true
    let  allowPaging = false
    let  allowDataBound = false
    let  allowGridSum = false
    let IsDialog = props.IsDialog || false
       
        // Defines the  string
        // @default ProformaInvoice${typeMode} 
        let ListSecurity='Chart Of Account'
        let AddSecurity='Chart Of Account'
        let EditSecurity='Chart Of Account'
        let DeleteSecurity='Chart Of Account'
        let ReportSecurity='Chart Of Account'
       
       // Defines the  ['Add','Edit','Delete','Update','Cancel','PDFExport','ExcelExport','Search','ColumnChooser'] | 'All'
       //  @default 'All'
      let toolbarOptions =['Add',  'Delete','Update','Cancel' , 'PDFExport','ExcelExport','Search','ColumnChooser'].filter(Boolean);
       ;
      


      //  const handleRedirectPreview = async (args) => {
      //    console.log(args)
      //    let reportServerPath = await securityService.ReportServerPath();
      //    console.log(reportServerPath);


      //   // Construct the URL with the parameters
      //   // http://asif-pc/ReportServer?
      //   // HS%2fTowelERP%2fExport%2fProformaInvoicePreview
      //   // &rs:Command=Render&rc:Toolbar=true&
      //   // EntryID=2&ExportOrderNo=0&ACodeCustomer=&PrintedByUserID=1
      //   //  EntryID=2&ExportOrderNo=0&ACodeCustomer=&PrintedByUserID=1
      //   //  const url = `${reportServerPath}%2fHS%2fTowelERP%2fExport%2fProformaInvoicePreview&rs:Command=Render&rc:Toolbar=true&EntryID=${args.EntryID || 0}&ExportOrderNo=${args.ExportOrderNo || 0}&ACodeCustomer=${args.ACodeCustomer || ''}&PrintedByUserID=${args.PrintedByUserID || 1}`;
      //   // Open the URL in a new tab and focus on it
      //   // const newTab = window.open(url, '_blank');
      //   // newTab.focus();
      // };
      

       const dialogRef = useRef(null);
       const showDialog = (header,title,actions =['OK']) => {
         return new Promise((resolve) => {
         // Destroy existing dialog if any
         if (dialogRef.current) {
           dialogRef.current.destroy();
         }
         const okButtons = actions.map((action) => ({
           buttonModel: {
             content: action,
             cssClass: 'e-flat',
             isPrimary: action === 'OK',
           },
           click: (e) => {
             hideDialog();
             resolve(action);
           },
         }));
         // Create a new dialog instance
         dialogRef.current = new DialogInput({
           content: ()=>(<>{title}</>),
           header:header,
           width:'340px',
           showButtons: true,
           buttons:okButtons
         });
         // Show the dialog programmatically
         dialogRef.current.show();

       });

       };
     const hideDialog = () =>{
       if (dialogRef.current) {
       }
       dialogRef.current.hide();
       dialogRef.current.destroy();
       dialogRef.current = null; // Clean up reference after destruction
     }
      const toolbarClicking =  async (grid , args , selectedRow , getListService)=>{
        console.log(args)
      //   if(args?.item?.properties?.id == 'DeleteWithDetail'){
      //     if(selectedRow == undefined){
      //   await showDialog('WARNING' ,<span class="error-tooltip">Please select a row first!</span>)
      // }else{
      //   let dialogResult  = await showDialog('Confirmation' ,<span class="error-success">Are you sure you want to delete?</span> , ['OK','CANCEL'])
      //   console.log(dialogResult)
      // if(dialogResult == 'OK'){
      //   chartOfAccountService.delete(selectedRow.ExportOrderNo).then(async (res)=>{
      //   await  showDialog('ALERT' ,<span class="error-success">RECORD(S) DELETED SUCESSFULLY</span>)
      //     await getListService()
      //       // AuditTable.auditDelete('UserInfo',selectedRow.EntryID,{
      //       //   EntryDate:moment(selectedRow.EntryDate).format('DD-MMM-YY'),
      //       //   CustomerOrderNo:selectedRow.CustomerOrderNo,
      //       //   CustomerName:selectedRow.CustomerName,
      //       //   ShipmentDate:moment(selectedRow.ShipmentDate).format('DD-MMM-YY'),
      //       //   ExportOrderDate:moment(selectedRow.ExportOrderDate).format('DD-MMM-YY'),
      //       //   OrderQuantity:selectedRow.OrderQuantity,
      //       // })
      //     })
      //   }
      //   }
      //   }
       }
       // Defines the 'Descending' | 'Ascending'
       //  @default 'Descending'
      let DefaultSortedColumnSort ='Ascending';

       /* Defines the [{
                    TableName:'ProformaInvoice' ,
                    TableID:'ProformaInvoiceID',
                   // Optional if Delete is Soft // TableSecurity:'ProformaInvoiceDelete',
                }]*/
    //  @default [] 
    //   let listDelete =  [{ TableName:'ProformaInvoice' ,TableID:'ProformaInvoiceID', Optional // TableSecurity:'ProformaInvoiceDelete'}]
    let listDelete =  [{ TableName:'ChartOfAccount' ,TableID:'AccountID'}];
       
    // Defines 'Hard' | 'Soft' 
    // @Default 'Hard'
    let deleteType = 'Hard'


/* Defines the [   {field:'IsDeleted',
OPTIONAL HAI operator:'equal' or more check syncfusion documentation
        value:'No'},...more
        ] | []
      @default [] */
    //   let filterColumns = [{ field: 'IsDeleted', value: 'No' }];
      let filterColumns = [];

      /* Defines the [ColumnNames] | []
      @default [] */
    //   let groupColumns = ['IsDeleted','AccountTitleHawalaDr'];
      let groupColumns = [];

/* Defines the 'Dialog' | 'Normal'
      @default 'Dialog' */
      let gridEditSettingMode = 'Dialog';

/* Defines the '<p></p>' | Can give HTML | AND REACT FUNCTION LIKE HeaderTemplate
      @default '<p></p>' */
      let gridEditSettingHeaderTemplate = '<p></p>';

      /* Defines the  [ColumnNames] | []
      @default [] */
           //   let gridSumColumns = ['HawalaCommissionPercent'];
      let gridSumColumns = [];


    return (
        <DynamicInputList
        Id='chartOfAccount'
        ListTitle={`Chart Of Account - List`}
        ColumnsList={columns}
        GridDataSource= {[
                    {
                        DataSourceType: 'Function',
                        DataSource:  ()=>   chartOfAccountService.getList()

                        }]}
        DefaultSortedColumnName={'AccountID'}
        GridDialog={[
            {
                DialogType:'Self',
                // Dialog:<ProformaInvoiceAdd ShopID={SecurityService.getLoggedInUserId() == 0 ? SecurityService.getLoggedInUserId() : SecurityService.getLoggedInShopID()} />
                Dialog:<ChartOfAccount  />
                // Dialog:<ProformaInvoiceAdd ShopID={1} /> 
                }
        ]}
        ListActionComplete={listActionComplete}
        ToolbarClicking ={toolbarClicking}

        //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
            AllowTemplate={allowTemplate}
            ToolbarOption={toolbarOptions}
            // AllowGrouping={allowGrouping}
            // AllowExcelExport={allowExcelExport}
            // AllowPdfExport={allowPdfExport} 
            // ShowColumnChooser={showColumnChooser}
            // AllowPaging={allowPaging}
            AllowDataBound={allowDataBound}
            ListSecurity={ListSecurity}
            AddSecurity={AddSecurity}
            EditSecurity={EditSecurity}
            DeleteSecurity={DeleteSecurity}
            DefaultSortedColumnSort={DefaultSortedColumnSort}
            // FilterColumns={filterColumns} /* IT USED WHEN GIVING FILTER IN GRID LIKE IsDeleted Column or more */
            // GroupColumns={groupColumns} 
            ListDelete={listDelete}
            DeleteType={deleteType} 
            // GridEditSettingMode={gridEditSettingMode}
            // GridEditSettingHeaderTemplate={gridEditSettingHeaderTemplate}
            // GridSumColumns={gridSumColumns}
            AllowGridSum={allowGridSum}
            IsDialog={IsDialog}
            {...props}
            ></DynamicInputList>
            
            );
}



export default ChartOfAccountInput;

